import { Component, OnInit, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-changelog',
  template: `
  @if(!isLoading()) {
    <div class="flex h-full w-full overflow-auto p-4 items-start">
      <p-card class="mx-auto w-2/3 p-4">
        <div class="p-4 m-2">
          <h1 class="text-[#90ee90] text-2xl font-bold mb-6 text-center">
            Changelog
          </h1>

          <input
            type="text"
            class="w-full mb-4 border p-2"
            placeholder="Search Changelog..."
            [(ngModel)]="searchTerm"
            (input)="filterMarkdown()"
          />

          <div class="prose text-[#9d9d9d] max-w-none">
            <markdown
              ngPreserveWhitespaces
              [data]="filteredMarkdown"
            ></markdown>
          </div>
        </div>
      </p-card>
    </div>
    }
  `,
  standalone: false
})
export class ChangelogComponent implements OnInit {
  markdown = '';
  filteredMarkdown = '';
  searchTerm = '';

  public isLoading = signal<boolean>(false);
  
  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.isLoading.set(true);
    this.http
      .get('../../../../assets/CHANGELOG_186.md', { responseType: 'text' })
      .subscribe(content => {
        this.markdown = content;
        this.filteredMarkdown = content;
        setTimeout(() => {
        this.isLoading.set(false);
        }, 100);
      });
  }

  filterMarkdown(): void {
    if (!this.searchTerm) {
      this.filteredMarkdown = this.markdown;
      return;
    }

    const term = this.searchTerm.toLowerCase();

    this.filteredMarkdown = this.markdown
      .split('\n')
      .filter(line => line.toLowerCase().includes(term))
      .join('\n');
  }
}
